
import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { connectNode } from '../../../../utils/global'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Spinner from 'react-spinner-material'

import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'

class WorksheetList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      error: '',
      dataItems: [],
      dataSGitems: [],
      dataRCitems: [],
      main_category_list: [],
      categoryByMain: {},
      worksheetByCategory: {},
    }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = async () => {
    this.setState({ loading: true, error: '' })

    try {
      const result = await axios({
        method: 'post',
        url: connectNode + 'admin/worksheets/get_worksheet_w_main_category',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
        },
        data: { pid: this.props.authReducer.uid },
      })

      const worksheet_list = result?.data?.[0]?.value || []
      const main_category_list = result?.data?.[1]?.value || []
      const category_list = result?.data?.[2]?.value || []

      const categoryByMain = category_list.reduce((acc, cat) => {
        const mainCategoryId = cat.main_category_id
        if (!acc[mainCategoryId]) {
          acc[mainCategoryId] = []
        }
        acc[mainCategoryId].push(cat)
        return acc
      }, {})

      const worksheetByCategory = worksheet_list.reduce((acc, worksheet) => {
        const categoryId = worksheet.category_id
        if (!acc[categoryId]) {
          acc[categoryId] = []
        }
        acc[categoryId].push(worksheet)
        return acc
      }, {})

      this.setState({
        main_category_list,
        categoryByMain,
        worksheetByCategory,
        loading: false,
      })
    } catch (error) {
      console.error('Failed to load worksheet data:', error)
      this.setState({
        loading: false,
        error: 'Unable to load worksheet data.',
      })
    }
  }

  convertDateFormat = (date) => {
    if (!date) return ''

    const buff1 = date.split(' ')
    const buff2 = buff1[0].split('-')

    if (buff2.length < 3) return date

    return `${buff2[1]}/${buff2[2]}/${buff2[0]}${buff1[1] ? ', ' + buff1[1] : ''}`
  }

  renderWorksheetTable = (worksheets = []) => {
    if (!worksheets.length) {
      return <div>No worksheets found.</div>
    }

    return (
      <table>
        <tbody>
          {worksheets.map((worksheet) => (
            <tr key={worksheet.id}>
              <td>{worksheet.name}</td>
              <td>
                <a href={`/admin/worksheets/assign_worksheets/${worksheet.id}`}>
                  Assign
                </a>
              </td>
              <td>
                <a href={`/member/worksheets/worksheet_pdf/${worksheet.id}`}>
                  Download
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  render() {
    const {
      loading,
      error,
      main_category_list,
      categoryByMain,
      worksheetByCategory,
      dataItems,
      dataSGitems,
    } = this.state

    return (
      <>
        <div className="patient_dashboard box_border4 patient_worksheets">
          <div className="row">
            <div className="small-12 columns headerPage1">
              Worksheets
            </div>
          </div>

          {loading && (
            <div className="loading1">
              <Spinner color="#bbbbbb" radius={50} />
            </div>
          )}

          {error && (
            <div className="warning_msg3">
              <div className="txt_warning_msg1">{error}</div>
            </div>
          )}

          {!loading &&
            main_category_list.map((main) => (
              <div className="row bottom_space1" key={main.id}>
                <div className="small-12 columns">
                  <p className="head2_1 bold">{main.main_category_name}</p>

                  {(categoryByMain[main.id] || []).map((cat) => {
                    const categoryId = cat.id || cat.category_id
                    const worksheets = worksheetByCategory[categoryId] || []

                    return (
                      <Accordion key={categoryId}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography>{cat.category_name}</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          {this.renderWorksheetTable(worksheets)}
                        </AccordionDetails>
                      </Accordion>
                    )
                  })}
                </div>
              </div>
            ))}
        </div>

      </>
    )
  }
}

const mapStateToProps = (state) => {
  //console.log('PatientList STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('PatientList mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(WorksheetList)
